<template>
  <span>
    <button class="btn btn-secondary"
            @click="showCreatePartitionModal"
    >
      <font-awesome-icon icon="layer-group" class="color-secondary mr-2"/>
      {{ $t('administration.partitions.create_button') }}
    </button>

    <!-- Create partition modal template -->
    <b-modal ref="create-partition" @hide="hideCreatePartitionModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreatePartitionModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-partitions-title">
            {{ $t('administration.partitions.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-partitions-error"
      >
        {{ error }}
      </b-alert>

      <b-form qid="create-partition-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-partition-name-label">
              {{ $t('administration.partitions.create.name_label') }}
            </label>
            <b-form-input
                qid="create-partition-form-name"
                type="text"
                v-model="clientForm.name"
                :maxLength="255"
                required
                :placeholder="$t('administration.partitions.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-partition-cvr-label">
              {{ $t('administration.partitions.create.cvr_label') }}
            </label>
            <b-form-input
                qid="create-partition-form-cvr"
                type="text"
                v-model="clientForm.cvr"
                :placeholder="$t('administration.partitions.create.cvr_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-partition-street-label">
              {{ $t('administration.partitions.create.street_label') }}
            </label>
            <b-form-input
                qid="create-partition-form-street"
                type="text"
                v-model="clientForm.street"
                :placeholder="$t('administration.partitions.create.street_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-partition-city-label">
              {{ $t('administration.partitions.create.city_label') }}
            </label>
            <b-form-input
                qid="create-partition-form-city"
                type="text"
                v-model="clientForm.city"
                :placeholder="$t('administration.partitions.create.city_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-partition-postcode-label">
              {{ $t('administration.partitions.create.postcode_label') }}
            </label>
            <b-form-input
                qid="create-partition-form-postcode"
                type="text"
                v-model="clientForm.postcode"
                :placeholder="$t('administration.partitions.create.postcode_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-partition-country-label">
              {{ $t('administration.partitions.create.country_label') }}
            </label>
            <multiselect
                v-model="selectedCountry"
                :options="countries"
                :multiple="false"
                :taggable="false"
                track-by="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('administration.partitions.create.country_label')"
                label="name"
                qid="create-partition-countries-select"
            >
              <template slot="singleLabel" slot-scope="props">
                <img v-bind:src="props.option.flag" height="13" class="align-baseline mr-1" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <img v-bind:src="props.option.flag" height="13" class="align-baseline mr-1" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-partition-ref-label">
              {{ $t('administration.partitions.create.reference_label') }}
            </label>
            <b-form-input
                qid="create-partition-form-cvr"
                type="text"
                v-model="clientForm.reference_number"
                :placeholder="$t('administration.partitions.create.reference_label')"
            ></b-form-input>
          </b-form-group>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreatePartitionModal"
                            qid="create-partition-cancel-button"
                  >
                    {{ $t('administration.partitions.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="createPartitionFormSubmit"
                            :disabled="buttonDisabled"
                            qid="create-partition-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('administration.partitions.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </span>
</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import permissionCheck from '@/util/ACL/permissionCheck.js'


export default {
  name: 'Partitions',
  data: function() {
    return {
      tableItems: [],
      clientForm: {
        client: '',
        slug: '',
        name: '',
        cvr: '',
        street: '',
        city: '',
        postCode: '',
        country: '',
        reference_number: '',
        country_with_flag: {},
      },
      countries: [],
      selectedCountry: [],
      error: '',
      loading: true,
      buttonDisabled: false,
    }
  },
  components: {
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    // getClient: function () {
    //  this.loadPartitions();
    //}
  },
  methods: {
    loadCountries() {
      let self = this;
      piincHttp.get('countries-with-flag').then(function(response) {
        self.countries = response.data
        //self.loadPartitions();
      }, function() {});
    },
    loadPartitions(query) {
      let self = this;
      piincHttp.get('partitions', { params: {
          client: self.getClient.parent ? self.getClient.parent.slug : self.getClient.slug,
          per_page: 0,
          sort: 'name',
          order: 'asc',
          mine: !this.getUser.isAdmin ? 1 : undefined
        }}).then(function(response) {
        self.partitions = response.data.items;

        if (self.getClient.parent) {
          self.client = self.getClient.parent;
          self.partition = self.getClient;
        } else {
          self.client = self.getClient;
          self.partition = [];
        }
      }, function() {});
    },
    isGranted(permission) {
      return permissionCheck(permission)
    },
    createPartitionFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      if (this.selectedCountry && this.selectedCountry.name) {
        this.clientForm.country = this.selectedCountry.name;
      }

      this.clientForm.client = this.getClient.slug;

      piincHttp.post('partitions/', this.clientForm).then(function(response) {
        self.buttonDisabled = false;
        self.hideCreatePartitionModal();
        //self.loadPartitions(loadPartitions);
        self.$toastr('success', self.$t('administration.partitions.create.success'))
        self.updateClient(response.data)
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    updateClient(client) {
      let self = this;
      let selectedClient = client;
      piincHttp.get('users/me/permissions/' + selectedClient.slug).then(function(response) {
        selectedClient.user_permissions = response.data.user_permissions
        selectedClient.user_roles = response.data.user_roles
        localStorage.setItem('clientObject', JSON.stringify(selectedClient));
        localStorage.setItem('client', selectedClient.slug);
        self.$store.commit('storeClient', selectedClient);
      }, function() {});
    },
    showCreatePartitionModal() {
      this.clientForm.name = '';
      this.clientForm.cvr = '';
      this.clientForm.street = '';
      this.clientForm.city = '';
      this.clientForm.postcode = '';
      this.clientForm.country = '';
      this.clientForm.reference_number = '';
      this.selectedCountry = [];

      this.$refs['create-partition'].show()
    },
    hideCreatePartitionModal() {
      this.$refs['create-partition'].hide()
    },
  },
  created () {
    this.loadCountries();
  }
}
</script>
